import React, { Component } from 'react';
import {
    phone, mail, cv, cv_green, people, salary, skill, work_exp, education, certificate, project, industry,
    art_certification, art_personal, art_education, art_project, art_salary, art_skills, art_work_exp, pen
} from "../../_redux/svg"

class Project_And_Awards extends Component {
    constructor() {
        super()
        this.state = {
            visible: false
        }
    }


    render() {
        const {dataProject} = this.props

        let visible = true
        if (dataProject.length>0){
            visible= false
        }
        return (
            <div className="h-100 bg-ff br-10 shd-input -set">
                <div className='flex column   mb-24'>
                    <div className='flex p-1814 bb-ea space-between'>
                        <div className='flex'>
                            <div className='flex m-auto-00'>
                                {project}
                            </div>
                            <p className='ml-14 DM-Sans c-29 s-20 '>Projects {"&"} Awards</p>
                        </div>
                        {!visible &&
                            <div className='flex pointer m-auto0' onClick={(e) => this.props.handlePopup("project_")}>
                                {pen}
                                <p className='DM-Sans s-14 c-36 ml6'>Edit</p>
                            </div>}
                    </div>
                    <div className='flex column  width-100 center'>
                        {visible &&
                            <div className='flex blank-data-main width-100 h-100'>
                                <div className='flex m-2429'>
                                    {art_project}
                                </div>
                                <div className='flex column ml-29  wd-375 center mb-48 mr-10'>
                                    <p className='c-29 DM-Sans s-14 mt-48 mb-48 tx-c'>Show the achievements you have accomplished throughout your career.</p>
                                    <div className='bg-36 p-1014 sm-m-2 button-w-main br-20 wd-fit-content pointer' onClick={(e) => this.props.handlePopup("add_project")}>
                                        <p className='s-14 c-ff DM-Sans '>Add Project {"&"} Awards</p>
                                    </div>
                                </div>
                            </div>}
                        {!visible &&
                            <div className='flex column align-left width-100 hg-100'>

                                <div className='flex column m-14'>
                                    {dataProject.length > 0 ? dataProject.map((item,i) => {
                                         if (i<=2){
                                            return(
                                        <div className='flex br-10 bd-d4 mb-14'>
                                            <div className='flex column p-14 width-100'>
                                                <p className='s-14 DM-Sans c-29 mb4'>{item.name}</p>
                                                <p className='DM-Sans c-36 s-14 '>{item.month} {item.year} </p>
                                            </div>
                                        </div>)}}) : ""}
                                    {/* <div className='flex br-10 bd-d4 mb-14'>
                                        <div className='flex column p-14 width-100'>
                                            <p className='s-14 DM-Sans c-29 mb4'>Scrum and Agile Methodologies</p>
                                            <p className='DM-Sans c-36 s-14 '>Feb 2017</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default Project_And_Awards;